<template>
  <main class="page-wrapper min-vh-100 bg-black">
    <div class="logout" v-on:click="logout">
      <i class="fa fa-sign-out"></i>
    </div>

    <div class="d-flex align-items-center justify-content-center">
      <div class="card bg-white entity-section-card p-4 shadow-sm border-0">
        <div class="mb-4">
          <h3 class="fw-bold h3">Which company would like to buy from?</h3>
          <p class="text-muted medium">
            Please select which company you want to buy from
          </p>
        </div>

        <form
          class="entity-form"
          autocomplete="off"
          v-on:submit.prevent="handleEntity"
          method="post"
        >
          <div class="entity-container">
            <label
              v-for="entity in entityDetails"
              :key="entity.id"
              class="entity-card d-flex align-items-center justify-content-between border rounded p-2 mb-3"
            >
              <div class="d-flex align-items-center gap-3">
                <div class="logo-wrapper">
                  <img
                    :src="entity.legal_company_logo"
                    :alt="entity.legal_company_name"
                    class="img-fluid"
                  />
                </div>
                <span class="fw-medium">{{ entity.legal_company_name }}</span>
              </div>

              <div class="radio-wrapper">
                <input
                  type="radio"
                  name="entity"
                  :value="entity.legal_company_code"
                  v-model="selectedEntity"
                />
                <span class="custom-radio"></span>
              </div>
            </label>
          </div>
          <button
            type="submit"
            class="btn form-control entity-btn"
            :disabled="isDisabled || loading"
          >
            <span v-if="loading">
              <i class="fa fa-spinner fa-spin"></i> Processing...
            </span>
            <span v-else class="continue"> Continue to company dashboard </span>
          </button>
        </form>
      </div>
    </div>
  </main>
</template>

<script>
import axios from "axios";

export default {
  name: "EntitySection",
  props: { msg: String },

  data() {
    return {
      selectedEntity: "FMNL",
      entityDetails: [],
      account: {},
      loading: false,
    };
  },

  watch: {
    $route: {
      immediate: true,
      handler() {
        document.title = "FMN Entity Selection Page";
        this.entityDetails = this.$store.getters.entityDetails;
        console.log("Entity Details from Store:", this.entityDetails);
      },
    },
  },
  mounted() {
    this.inactivityTime();
  },
  computed: {
    isDisabled() {
      return !this.selectedEntity;
    },
  },

  methods: {
    async handleEntity() {
      this.loading = true;
      try {
        this.$store.commit("set_entity", this.selectedEntity);

        const success = await this.handleAccountLegalEntity();

        if (success) {
          this.$router.push("/home");
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        this.loading = false;
      }
    },

    async handleAccountLegalEntity() {
      try {
        this.account.primary_legal_entity = this.$store.getters.entity;
        this.account.vendor_no = this.$store.getters.vendor_no;

        let data = this.loadNew(this.account);
        const res = await axios({
          method: "get",
          url: this.$hostname + "/get-accounts-by-legal-entity",
          headers: {
            "Content-Type": "application/json",
            "X-Request-IV": data.iv,
            Authorization: `Bearer ${this.$store.getters.headerstoken}`,
          },
          params: {
            token: data.cipher,
          },
        });

        if (!res.data.data || res.data.data.length === 0) {
          const legalEntity = res.data.primary_legal_entity;
          const errorMessage =
            legalEntity === "FMNL"
              ? "FMN account isn't registered for this user yet"
              : "Honeywell account isn't registered to this user yet";

          this.$swal.fire("Error", errorMessage, "error");
          return false;
        }

        this.$store.commit("set_subaccounts", res.data.data);
        return true;
      } catch (error) {
        console.error("Error during login:", error);
        return false;
      }
    },
  },
};
</script>

<style>
.logout {
  height: 50px;
  width: 50px;
  background-color: #006e40;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  display: flex;
  margin: 10px;
  cursor: pointer;
}
.logout i {
  color: white;
}

.continue {
  font-size: 14px;
  text-transform: capitalize;
}
</style>
